import type { GlobalToken } from "antd"

// Muted on purpose: a signer's colour marks ownership on the page and beside
// their name, and is never the only way to tell signers apart.
const SIGNER_COLORS = [
  "#2E8593", // teal
  "#7B61C2", // violet
  "#B07A1F", // amber
  "#B4516E", // rose
  "#4E72B8", // blue
  "#4C8A62" // green
] as const

export const signerColor = (_token: GlobalToken, index: number): string =>
  SIGNER_COLORS[Math.max(index, 0) % SIGNER_COLORS.length]

export const tint = (color: string, alpha = 0.1): string => {
  const hex = color.replace("#", "")
  if (!/^[0-9a-f]{6}$/i.test(hex)) return color
  const [r, g, b] = [0, 2, 4].map((at) => parseInt(hex.slice(at, at + 2), 16))
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
